import { createCRUDHook } from './createCRUDHook';
import { CostMethodDto } from 'utils/models';
import { COST_METHOD } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<CostMethodDto>({
  entityName: 'CostMethod',
  endpoint: COST_METHOD,
});

export const CostMethodContext = Context;
export const useCostMethodManager = useManager;
export const useCostMethod = useConsumer;
